import React from "react";
import { useTranslation } from "react-i18next";
import { useRafflePageContext } from "./RafflePageContext";
import cls from "./styles.module.scss";
import { formatRaffleFinishedAt, getRaffleTimeLeft } from "./utils";

const RaffleTimeIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8.64286 5C8.64286 4.64496 8.35504 4.35714 8 4.35714C7.64496 4.35714 7.35714 4.64496 7.35714 5V8C7.35714 8.20234 7.45241 8.39288 7.61429 8.51429L9.32857 9.8C9.6126 10.013 10.0155 9.95546 10.2286 9.67143C10.4416 9.3874 10.384 8.98445 10.1 8.77143L8.64286 7.67857V5Z"
      fill="#FCBD00"
    />
  </svg>
);

export const RaffleTimer = () => {
  const { t } = useTranslation();
  const { raffle } = useRafflePageContext();
  const timeLeft = getRaffleTimeLeft(raffle.scheduled_draw_at);
  const timerText = (() => {
    if (raffle.drawn_at) {
      return t("raffle.timer.finishedAt", {
        date: formatRaffleFinishedAt(raffle.drawn_at),
      });
    }

    if (timeLeft.totalMs < 60 * 60 * 1000) {
      return t("raffle.timer.endsInMinutes", { count: timeLeft.minutes });
    }

    if (timeLeft.totalMs < 24 * 60 * 60 * 1000) {
      return t("raffle.timer.endsInHoursMinutes", {
        hours: timeLeft.hours,
        minutes: timeLeft.minutes % 60,
      });
    }

    return t("raffle.timer.endsIn", { count: timeLeft.days });
  })();

  return (
    <div className={cls.raffleTimer}>
      <RaffleTimeIcon />
      {timerText}
    </div>
  );
};
